/**
 * useRejectLeave — React Query mutation szabadság elutasításához
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { rejectLeave, type LeaveRequest } from '../api/hr-api';
import { leaveCalendarQueryKey } from './useLeaveCalendar';
import { leaveRequestsQueryKey } from './useLeaveRequests';

export function useRejectLeave() {
  const queryClient = useQueryClient();

  return useMutation<LeaveRequest, Error, string>({
    mutationFn: async (id: string) => {
      const res = await rejectLeave(id);
      return res.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: leaveRequestsQueryKey });
      const now = new Date();
      void queryClient.invalidateQueries({
        queryKey: leaveCalendarQueryKey(now.getFullYear(), now.getMonth() + 1),
      });
    },
  });
}
